import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { styled } from 'styled-components';
export const Component = styled.svg `
  min-width: ${({ width }) => `${width}px`};
`;
const _FileTypeBaseComponent = ({ className, onClick, dataTestId, ref, iconRender, viewBox = '0 0 30 36', }) => (_jsx(Component, { className: className, onClick: onClick, ref: ref, width: 30, height: 36, viewBox: viewBox, fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "data-testid": dataTestId, children: iconRender() }));
export const FileTypeBaseComponent = React.memo(_FileTypeBaseComponent);
